// Tracks the hand-off between the attendance report tour and the settings
// setup tour. sessionStorage is per-tab, so an abandoned setup resumes if the
// user returns to attendance settings in the same tab and clears when the tab
// closes.
const KEY = 'attendance-tour-setup'

export const AttendanceTour = {
  startSetup() {
    sessionStorage.setItem(KEY, 'active')
  },

  setupActive() {
    return sessionStorage.getItem(KEY) === 'active'
  },

  endSetup() {
    sessionStorage.removeItem(KEY)
  }
}
